import {MessageWithActionAndData} from "@me8eon/sessions_messages";
import {Icon} from "@me8eon/icons";
import React from "react";

const UserMessage = ({ content, condition }: MessageWithActionAndData) => {
    const finalContent = condition ? condition(content) : content;
    return (
        <div className="user-header">
            <div className="user-logo">
                <Icon name="user" />
            </div>
            <div className="user-reply-container">
                <div className="bot-text">{finalContent}</div>
            </div>
        </div>
    );
};

export default UserMessage;